<template>
    <div class="zebra-crossing-detail">
        <el-form :model="detail">
            <div class="zebra-item">
                <div class="zebra-item_tit">发布登记单</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="所属公司：">{{ detail.company | tableVal(companyList,'n') }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="申请人：">{{ detail.requester.name}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发布类型：">{{ detail.deployType | tableVal(deployType) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发布类别：">{{ detail.deployClass | tableVal(deployClass) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发布分类：">{{detail.category|tableVal(deployList,'t')}} </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="涉及数据库：">{{ detail.database | tableVal(dataBaseList,'t') }}</el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发布版本：">{{ detail.version }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="计划发布时间：">{{ detail.deployTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发布来源：">{{ detail.deployOrigion |tableVal(deployOrigin) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发布标题：">{{detail.title}}</el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="优先级：">{{ detail.priority |tableVal(priority)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="紧急度：">{{ detail.emergency | tableVal(emergency) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="标签：">
                            <span v-for="item in detail.label">{{ item }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="风险等级：">{{ detail.risk | tableVal(risk) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="完成程度：">
                            {{detail.completionDegree|tableVal(completionDegree)}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="环境：">{{detail.env|tableVal(env)}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="项目名称：">
                            {{detail.projectName|tableVal(projectName)}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="服务请求：">{{detail.serviceClass|tableVal(serviceClass)}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="完成时间：">
                            {{detail.endTime}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否高危操作：">
                            {{detail.isHighRiskOperation ?'是':'否'}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="上传附件：">
                            <ul>
                                <li v-for="item in detail.attachment" >
                                    <a :href="item.url" style="color: #1890EF">{{ item.name }}</a>
                                    <span>上传时间:&emsp;{{item.uploadTime?item.uploadTime:'无'}}</span>
                                    <span class="preview" @click="previewEvent(item)">预览</span>
                                </li>
                            </ul>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="可交付结果：" >{{detail.result}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="测试方案：" >{{detail.testPlan}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="失效应急方案：" >{{detail.failPlan}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="培训计划：" >{{detail.trainPlan}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item  label="详细描述：" >
                            <span v-html="detail.description"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    import commonService from "../../../services/common.service"
    export default {
        props:{
            detail:Object,
            deployList:Array,
            dataBaseList:Array,
            companyList:Array,
        },
        data() {
            return {

            }
        },
        created() {

        },
        computed:{

            dictionary(){
                return this.$store.state.dictionary;
            },
            //发布分类
            deployCategory(){
                return this.dictionary.deploy_category;
            },
            //发布类型
            deployType(){
                return this.dictionary.deploy_type;
            },
            //变更类别
            deployClass(){
                return this.dictionary.deploy_class;
            },

            //发布来源
            deployOrigin(){
                return this.dictionary.deploy_origion;
            },

            // 优先级
            priority(){
                return this.dictionary.priority;
            },
            // 紧急度
            emergency(){
                return this.dictionary.emergency;
            },
            //风险等级
            risk(){
                return this.dictionary.deploy_risk
            },
            completionDegree(){
                return this.dictionary.completion_degree
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },


        },
        methods: {
            previewEvent(row){
                // console.log(row)
                this.$router.push({
                    name:'Preview',
                    path:'/preview',
                    query: {
                        file:row
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .zebra-crossing-detail .zebra-item .el-form-item__content a{
        float: left;
        margin-left: 20px;
    }
    .preview{
        color:blue;
        cursor: pointer;
        margin-left: 10px;
    }
</style>
